module.exports = __webpack_public_path__ + "static/media/new-town.60c9c68e.png";